/*
 * Filename: \src\Settings\Vendors\AddVendor\EnterName.js
 * Created Date: 2025-12-10 12:40
 * Author: jdkohl
 * 
 * Copyright (c) 2025 Logical Developments
 */

import { useAddVendorContext } from "./AddVendorContext"


export default function EnterName() {
  const { vendor, updateVendor } = useAddVendorContext();
  return (
    <div className="stack container__height-full height-full">
      <h3>Add New Vendor</h3>
      <div className="stack stack-center height-full">
        <label
          htmlFor="vendorName"
          className="label__above"
        >
          Vendor Name:
          <input
            id="vendorName"
            value={vendor?.name}
            onChange={(e) => updateVendor({ type: "key", key: "name", value: e.target.value })}
            required
          />
        </label>
        {/* </div>
      <div> */}
        <label
          htmlFor="vendorEmail"
          className="label__above"
        >
          Vendor Email Address:
          <input
            className="width-full"
            id="vendorEmail"
            type="email"
            value={vendor?.email}
            onChange={(e) => updateVendor({ type: "key", key: "email", value: e.target.value })}
            required
          />
        </label>
      </div>
    </div>
  )
}